import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import { AppConstants } from './app-constants.service';
import { VertragHandle } from '../generated/api/kreditportalBackendAPI.schemas';

export interface TokenProps {
    timestamp: number;
    userName: string;
    role: string;
    app: string;
}

@Injectable()
export class AppState {

    lastVertragDisplayed?: VertragHandle;

    private lastGeschaeftsjahrDisplayed?: string;

    private lastURL?: string;

    private readonly urlMap: Map<string, string> = new Map<string, string>();

    constructor(
        private readonly router: Router,
        private readonly appConstants: AppConstants,
    ) {
    }

    storeURL(): void {
        this.lastURL = window.location.pathname.substring(this.appConstants.baseHref.length);
    }

    registerForLastUrl(): void {
        const here: string = window.location.pathname;
        this.urlMap.set(here, decodeURI(this.lastURL ?? ''));
    }

    putString(key: string, value: string) {
        sessionStorage.setItem(key, decodeURI(value));
    }

    getString(key: string) {
        return sessionStorage.getItem(key);
    }

    saveToken(token: TokenProps): void {
        sessionStorage.setItem('token', JSON.stringify(token));
    }

    setLastGeschaeftsjahrDisplayed(lastGeschaeftsjahrDisplayed: string): void {
        this.lastGeschaeftsjahrDisplayed = lastGeschaeftsjahrDisplayed;
        this.putString('lastGeschaeftsjahrDisplayed', lastGeschaeftsjahrDisplayed);
    }

    getLastGeschaeftsjahrDisplayed(): string | null {
        return this.lastGeschaeftsjahrDisplayed || this.getString('lastGeschaeftsjahrDisplayed');
    }

    removeSavedToken(): void {
        sessionStorage.removeItem('token');
    }

}
